import React from 'react';
import RestrictedActionForm from './RestrictedActionForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { useRestrictedActionShowState, useRestrictedActionShowActions } from './RestrictedActionShowContext';
import { updateRestrictedAction } from './restApi';

import styles from './RestrictedActionModal.module.scss';

const RestrictedActionEditModal = () => {
  const state = useRestrictedActionShowState();
  const { closeRestrictedActionEditModal, onResponse, onError } = useRestrictedActionShowActions();

  return (
    <StandardModal
      isOpen={state?.restrictedActionEditModalIsOpen}
      onRequestClose={() => {
        closeRestrictedActionEditModal();
      }}
    >
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          Update Restricted Action
        </h2>
        <RestrictedActionForm
          restrictedAction={state?.restrictedAction}
          onSubmit={(args) => {
            updateRestrictedAction({
              ...args,
              onResponse,
              onError,
            });
          }}
          onCancel={closeRestrictedActionEditModal}
        />
      </section>
    </StandardModal>
  );
};

export default RestrictedActionEditModal;
